import RenderLoading from './render-loading';
import RenderLoadingList from './render-loading-list';
export { RenderLoadingList };
export default RenderLoading;